import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const ZoneList = Loadable(lazy(() => import("./ZoneList")));
const ZoneForm = Loadable(lazy(() => import("./ZoneForm")));

const zoneRoutes = [
  {
    path: "/Zone/ZoneList",
    element: <ZoneList />,
    permission: PERMISSIONS.Zones.Menu,
  },
  {
    path: "/Zone/ZoneForm",
    element: <ZoneForm />,
  },
  {
    path: "/Zone/ZoneForm/:zoneId",
    element: <ZoneForm />,
  },
];

export default zoneRoutes;
